import styled from 'styled-components'

export const ReinforcementTitle = styled.p`
  color: ${props => props.theme.colors.green900};
  margin: 0;

  font-size: 2em;
  font-weight: 600;
  line-height: 130%;
`

export const ReinforcementTitleHighlight = styled.span`
  color: ${props => props.theme.colors.primary};
`

export const ReinforcementDescription = styled.p`
  color: ${props => props.theme.colors.text};
  margin: 0;

  font-size: ${props => props.theme.fontSizes.medium};
  font-weight: 400;
  line-height: 150%;
  hyphens: auto;
  hyphenate-character: '\u2013';
`

export const ReinforcementDescriptionHighlight = styled.span`
  font-weight: 600;
`
